import { unsubscribePushService } from '@/services/Notifications';
import { getPushSubscription, isPushSupported } from './pushNotifications';

/**
 * Logout MANUAL: desvincula este dispositivo del usuario en la API (`DELETE subscriptions/`)
 * para que no reciba los avisos del usuario que sale. NO desuscribe el navegador: si vuelve
 * a entrar, el resync de `PushServiceWorkerRegistration` lo re-vincula. Best effort y con
 * tope de `timeoutMs` para no demorar el logout.
 */
export const unlinkDeviceFromPush = async (timeoutMs = 1000): Promise<void> => {
  if (!isPushSupported()) return;
  const work = (async () => {
    try {
      const subscription = await getPushSubscription();
      if (!subscription) return;
      await unsubscribePushService({ endpoint: subscription.endpoint });
    } catch {
      // Best effort.
    }
  })();
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<void>((resolve) => {
    timer = setTimeout(resolve, timeoutMs);
  });
  await Promise.race([work, timeout]);
  if (timer) clearTimeout(timer);
};
